function requireAuth(auth){
  if(!auth?.getSession||!auth?.onSessionChange)throw new TypeError('auth adapter with getSession/onSessionChange is required');
  return auth;
}

export function createSessionRuntime({auth,diagnostics,onChange=()=>{}}={}){
  const adapter=requireAuth(auth);
  let currentSession=null;
  let unsubscribe=null;
  let started=false;

  function publish(event,session){
    currentSession=session||null;
    try{onChange(Object.freeze({event,session:currentSession}));}
    catch(error){diagnostics?.capture?.('auth.session-listener',error);}
  }

  async function start(){
    if(started)return currentSession;
    started=true;
    try{
      publish('INITIAL_SESSION',await adapter.getSession());
    }catch(error){
      diagnostics?.capture?.('auth.session-restore',error);
      publish('INITIAL_SESSION',null);
    }
    try{
      unsubscribe=adapter.onSessionChange(({event,session})=>publish(event,session));
    }catch(error){
      diagnostics?.capture?.('auth.session-subscribe',error);
    }
    return currentSession;
  }

  function stop(){
    try{unsubscribe?.();}catch(error){diagnostics?.capture?.('auth.session-unsubscribe',error);}
    unsubscribe=null;
    started=false;
  }

  return Object.freeze({start,stop,getSession:()=>currentSession,isStarted:()=>started});
}
